<template>
  <div>
    <div id="chart-container" class="by-moat">
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" id="cp-by-moat-e-chart" class="chart-row">
        <profile-chart-header
            :title="'Moat Profile | ' + titleSuffix"
            :display="this.$parent.getDisplayView() && getDisplayView()"
            :content-list="contentList"
            :content-name="'Moat Profile'"
            :input-display-number-of-responses="eChartCriteria.displayNumberOfResponses"
            :input-show-tooltip="eChartCriteria.showTooltip"
            :display-download-comments="true"
            @set-display-number-of-responses="setDisplayNumberOfResponses"
            @set-show-tooltip="setShowTooltip"
        />           
        <profile-chart ref="eChart"
            :e-chart-mini-id="'profile-chart-moat-mini'"
            :e-chart-id="'profile-chart-moat'"
            :input-report-type-name="'Chart - Moat Profile'"
            :modal-id="'profile-by-moat-chart'"
            :is-saved-card="$parent.clientChart.clientChartId != 0" 
            :input-client-chart="this.$parent.clientChart"
            :client-id="clientId"
            :inputDownloadFileName="'Moat Profile - ' + titleSuffix"
            @save-table="saveProfileDataTable"
            @save-criteria="buildClientChart"/>        
      </div>      
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" :id="moatNeedsTable.tableContainerId" :class="isInsiderUser ? 'chart-data hide-table-data' : 'chart-data'">
        <div v-show="isInsiderUser" class="overlay">
          <img class="overlay-inner" v-show="isInsiderUser" src="../../../assets/img/overlap.png" style="width: 50%"/>
        </div>
        <chart-data-table
          ref="moatDataTable"
          v-show="this.$parent.getDisplayView() && getDisplayView()"
          :chart-data="this.moatNeedsTable.data"
          :display-direction="'vertical'"
          :data-container-id="moatNeedsTable.tableContainerId"
          :container-id="'moat_functional_needs_chart'"
          :is-saved-card="$parent.clientChart.clientChartId != 0"           
          :content-list="this.pageContentForMoats"
          :column-defs="this.chart.columnDefs"
          :table-class="'table display row-border table-hover'"
          :table-width="'auto'"
          :report-page-type-name="'Table - Moat Profile'"
          :insight-modal-id="'profile-by-moat-table'"
          :table-title="this.moatNeedsTable.title"
          :inputDownloadFileName="'Moat Profile - ' + titleSuffix"
          :effort-list="needsEffortList"
          :use-alternate-title="true"
          :display-profile-strength-legend="$parent.displayProfileStrengthLegend"
          @display-initiatives="$parent.displayInitiativesForProfileTable"
          @go-to-explore="$parent.goToExploreForProfileTable"
        ></chart-data-table>
      </div>
    </div>
    <div v-for="(pageContent, idxPageContent) in pageContentForMoats" v-bind:key="idxPageContent">
      <modal :modal-id="pageContent.title" :modal-title="pageContent.title" :modal-content="pageContent.contentText" />
    </div>
    
    <insights
      ref="insightsChart"
      :modal-name="'profile-by-moat-chart'"
      :report-page-type-name="'Chart - Moat Profile'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsTable"
      :modal-name="'profile-by-moat-table'"
      :report-page-type-name="'Table - Moat Profile'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
  </div>
</template>
<script>
import $ from "jquery";
import ProfileChart from "../../../views/echarts/ProfileChart.vue";
import ProfileChartHeader from "../../../components/echarts/ProfileChartHeader.vue";
import ProfileService from "../../../services/echarts/profile.service";

import ChartCompanyMixins from "../../../mixins/ChartCompanyMixins.vue";
import ChartService from "../../../services/chart.service";
import ErrorService from "../../../services/error.service";
import AdminService from "../../../services/admin.service";
import NeedsService from "../../../services/needs.service";
import TableService from "../../../services/table.service";
import ReportService from "../../../services/report.service";
import ContentService from "../../../services/content.service";

export default {
  name: "ByMoat",
  mixins: [ChartCompanyMixins],
  components: {  ProfileChart, ProfileChartHeader},
  data() {
    return {
      displayType: "moat",
      pageContentForMoats: [],
      needsEffortList: [],
      moatNeedsTable: {
        id: "",
        data: {},
        title: '<div class="title"><h4 class="text-primary">Moat Profile</h4></div>',
        tableContainerId: "moat_needs_data_container",
      },
      isMobile: false,
      titleSuffix: "",
    };
  },
  props: {
    verbatimsData: {
      type: Array,
      default: function() {
        return [];
      }    
    },
    chartData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    contentList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    surveyCode: function() {
      return this.$parent.$data.survey.surveyCode;
    },    

  },
  mounted() {},
  created() {
        ContentService.getPageContent("Moats", this.getPageContentByMoatsCallBack, this);
  },
  methods: {
    getPageContentByMoatsCallBack(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.pageContentForMoats = response.data.data;
      }
    },
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Chart - Moat Profile") {
        this.$refs.insightsChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsChart.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Table - Moat Profile") {
        this.$refs.insightsTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsTable.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      }
    },
    async processChartData() {
      try {
        
        this.chart = ChartService.getChartAttributes("Profile By Moat");
        this.$parent.pageContent.push(...this.contentList);
        this.pageContentForMoats.push(...this.contentList);
        let needsData = JSON.parse(JSON.stringify(this.chartData[0]));
        let otherData = needsData["otherData"];
        let titleSuffix = otherData["titleSuffix"];
        if (typeof titleSuffix != "undefined" && titleSuffix != null && titleSuffix != "") {
          this.titleSuffix = titleSuffix;
        }
        
        let needsList = otherData["needsList"];
        let emotionalNeedNamesMap = otherData["emotionalNeedNamesMap"];
        let moatsList = otherData["moatsList"];
        this.needsEffortList = otherData["effortList"];
        let companyColorList = otherData["companyColorList"];
        let breakPointList = otherData["breakPointList"];
        this.$parent.selectedValueRoadMapId = otherData["selectedValueRoadMapId"];
        TableService.setCompanyColorList(companyColorList);

        let containerId = needsData["containerId"];

        let chartContainerWidth = $("#" + containerId).width();
        if (chartContainerWidth < ChartService.getMobileBreakpoint()) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }

        this.table.id = containerId;

        NeedsService.setMoatsList(moatsList);
        ChartService.setVerticalLineBreakPoints(breakPointList);
        let copyOfChartData = JSON.parse(JSON.stringify(needsData));

        
        let originalEmotionalNeedsData = JSON.parse(JSON.stringify(this.chartData[1]));
        copyOfChartData.rows.push(...originalEmotionalNeedsData.rows);
        this.$parent.setChartResults(needsData.companyList);
        this.$parent.$data.criteriaResultsList = AdminService.removeByName(needsData.criteriaList, "Competitor");
        let showRelationshipStrength = this.$parent.$data.criteriaResultsList.find(item => item.name === "Show Relative Strength");
        if (typeof showRelationshipStrength != "undefined" && showRelationshipStrength.displayValue == "Yes") {
          this.$parent.displayProfileStrengthLegend = true;
        } else {
          this.$parent.displayProfileStrengthLegend = false;
        }

        needsData = this.drawSingleEmotionalNeedsName(needsData);

        if (otherData["moatMapDataList"] != "undefined") {
          this.$parent.valueMapData.data = otherData["moatMapDataList"];
        }
        this.$parent.valueMapData.title = this.$parent.survey.name + " Moat Map";
        this.moatNeedsTable.id = containerId;
        let labelIndex = 1;
        for (let indexRows = 0; indexRows < copyOfChartData.rows.length; indexRows++) {
          let copyOfChartDataRow = copyOfChartData.rows[indexRows].c;
          let originalName = copyOfChartDataRow[labelIndex].v;
          if (originalName != null && originalName.includes(",")) {
            let emotionalNeedMap = emotionalNeedNamesMap.find(item => item.needName === originalName);
            if (typeof emotionalNeedMap != "undefined") { 
              copyOfChartDataRow[labelIndex].v = emotionalNeedMap.dimensionName;
            } 
          }
        }
        this.$parent.needsList = needsList;
        let columns = needsData["cols"];
        let isPositiveCorrelation = otherData["isPositiveCorrelation"];
        this.chart.columnDefs = this.buildColumns(columns,isPositiveCorrelation);
        this.moatNeedsTable.data = copyOfChartData;
        
        this.$root.$emit("check-number-of-responses");
        this.setEChartCriteria(this.$parent.$refs.chartCriteria.eChartCriteria);
        this.eChartCriteria.eChartType = "stacked-bar-vertical";
        this.parseProfileDataForNeed(JSON.parse(JSON.stringify(this.chartData)));
        this.sortData();
        this.processVerbatimsData();
        // for AI Profile Recommendations
        this.setRecommendationsData(copyOfChartData, isPositiveCorrelation);

        this.$refs.eChart.processChart(true,"moat",this.eChartData,this.eChartCriteria,this.$parent.showPricingPower);
        $("#cp-by-moat-e-chart").addClass("chart-wrapper");
        this.setDisplayView(true);
        this.$parent.setDisplayView(true);
      } catch (err) {
        ErrorService.processException("ByMoat.displayChartCallback", err, "chart", this);
      }
    },
    processVerbatimsData: function(){
      if (!$.isEmptyObject(this.verbatimsData)) {
        this.eChartData.verbatims = (JSON.parse(JSON.stringify(this.verbatimsData))); 
        if (this.chartData.length == 0) {
          return;
        }
        this.$refs.eChart.processChart(true,"moat",this.eChartData,this.eChartCriteria,this.$parent.showPricingPower);
      }
    },
    buildColumns(columns,isPositiveCorrelation = true){
      let returnColumns = [
          TableService.getOrderSequence(),
          {
            targets: [0],
            className: "dt-left",
            width: 120,
            render: function(data, type, row, meta) {
              if (data == null) {
                return " ";
              }              
              var parameters = meta.settings.oInit.columnDefs[meta.col].parameters;
              return data;
            }
          },
          {
            targets: [1],
            className: "dt-left",
            width: 190,
            render: function(data, type, row, meta) {
              if (data == null) {
                return null;
              }
              var parameters = meta.settings.oInit.columnDefs[meta.col].parameters;
              let originalData = data;
              data = data.length > 40 ? data.substr(0, 40) + "…" : data;
              let displayData = data;
              let includeToolTip = data.length > 40;

              if (type === "display"  && originalData != "Functional Average" && originalData != "Emotional Average" && originalData != "Overall Average") {
                let isEmotional = NeedsService.isEmotionalNeedByDimensionName(data);
                let needType = isEmotional ? "emotional" : "functional";
                let fieldNumber = NeedsService.getNeedNumber(data, needType);
                if (fieldNumber == 0) {
                  fieldNumber = meta.row + 1;
                }
                let needName = isEmotional ? "Emotional Need " : "Functional Need ";
                needName += fieldNumber;
                data = '<span class="popUpForRoadMapInitiatives"  data-modal-name="' + needName + '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/icons/wratings-mini-logo.png" class="icon-table-view"/></span>';
                data += ' <span class="popUpForExplorer"  data-modal-name="' + needName + '" data-need-number="' + fieldNumber + '" data-need-type="' + needType + '"><img src="/img/magnifying-glass-dollar.svg" class="icon-table-view"/></span>';                
                if (includeToolTip) {
                  data += '<span data-toggle="tooltip" title="' + originalData + '">' + displayData + "</span>";
                } else {
                  data += displayData;
                }
              }
              return data;
            }
          },
          TableService.getNumericTableAttribute([2], "dt-right", 50),
          TableService.getNumericTableAttribute([3], "dt-right", 50),
          TableService.getNumericTableAttribute([4], "dt-right ", 50),
      ];
      let position = 0;
      columns.forEach(function(column) {
        if (position >= 5){
          if (column.id == "pricing-power"){
            returnColumns.push(TableService.getPercentTableAttribute([position], "dt-right", 50, 2)); // Pricing Power
          } else if (column.id == "relative-strength"){
            returnColumns.push(TableService.getRelativeStrengthTableAttribute([position], "dt-right", 50, 2,isPositiveCorrelation)); // Relative Strength
          } else if (column.label == "Metric" || column.label == "Growth Ideas" || column.label == "Roadmap Initiatives") {
            returnColumns.push(TableService.getMetricTableAttribute([position], "dt-left", 200, 2));
          } else {
            returnColumns.push(TableService.getNumericTableAttribute([position], "dt-right", 50));
          }
        }
        position++;
      });
      returnColumns.push(TableService.getNumericTableAttribute(["_all"], "dt-right", 50));
      return returnColumns;
    },
    sortData:function() {
        let columnIndex = 1;
        let chart2Data = this.eChartData.chart2.data;
        chart2Data.sort((a, b) => {
          let aValue = parseFloat(a[columnIndex]);
          let bValue = parseFloat(b[columnIndex]);
          if (isNaN(aValue)) {
            aValue =  0; 
          }
          if (isNaN(bValue)) {
            bValue = 0; 
          }
          return bValue - aValue; // descending 
        });
        this.eChartData.chart2.data = JSON.parse(JSON.stringify(chart2Data));
    },
    parseProfileDataForNeed: function(inputData){
      let itemsToRemove = {
        lastColumns: 0,
        firstColumns: 1,
        gapColumn: 1,
      };      
      let itemsToRemoveEmotionalNeeds = {
        lastColumns: 0,
        firstColumns: 1,
        gapColumn: 1,
        lastRows: 3
      };         
      let data = {};
      // Functional Needs
      let chart1Data = inputData[0];
      // Emotional Needs
      let chart2Data = inputData[1];
      data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
      data = ProfileService.parseData(2,chart2Data,data,itemsToRemoveEmotionalNeeds);
      data = ProfileService.parseLegendAndColorData(inputData[0],data);
      this.eChartData = JSON.parse(JSON.stringify(data));
    },    
    async saveProfileDataTable(){
      if (this.$parent.clientChart.clientChartId != 0 && this.isGenerateReportRunning()) {
        let vm = this;
        setTimeout(function() {
          ReportService.saveReportTableFile(vm.$refs.moatDataTable.getTableData(), "Table - Moat Profile", vm.$parent.clientChart, vm.saveReportTableFileCallback,vm);
          ReportService.saveReportPage(vm.getReportTableContent("moat_functional_needs_chart"),"Table - Moat Profile", vm.$parent.clientChart, vm.saveReportPageCallback, vm);
        }, 1500);        
      }
    },
    saveAllReportPages() {
        this.saveProfileDataTable();
    },
    async saveInstantReportChartImage(clientReportId) {
      if (clientReportId != 0) {
        await this.$refs.eChart.saveImageForInstantReport(clientReportId,'Moat Profile | ' + this.titleSuffix);
      }
    },
  },
  watch: {
    surveyCode: function() {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.$refs.eChart.clear();} catch(e){}
    },
    verbatimsData: function() {
      if (this.$parent.$refs.chartCriteria.$data.displayType == "moat") {
        this.processVerbatimsData();
      } 
    },
    chartData: function() {
      if (this.$parent.isByMoat) {
        this.processChartData();
      } else {
        this.setDisplayView(false);
      }
    }
  }
};
</script>
